import type { ClientChatMessage } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { Mutation } from '@tanstack/react-query';
import { useMutationState } from '@tanstack/react-query';
import { useCallback } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import type { CreateChatMessageParams } from '@/features/api/hooks/communication-chat-events/useSendChatMessage';
import { useAppState } from '@/features/authorization/provider/useAppState';

export const usePendingChatMessages = (chatId: string) => {
  const { userId } = useAppState();

  const select = useCallback(
    (mutation: Mutation): ClientChatMessage => {
      const params = mutation.state.variables as CreateChatMessageParams;
      return {
        id: `pending_${params.created}`,
        autoGenerated: false,
        chatId,
        created: params.created,
        message: params.message,
        sentTime: undefined,
        senderId: userId
      };
    },
    [chatId, userId]
  );

  return useMutationState<ClientChatMessage>({
    filters: {
      mutationKey: [API_CACHE_KEYS.PENDING_CHAT_MESSAGES, chatId],
      status: 'pending'
    },
    select
  });
};
